import { render } from "./CommonModal.vue?vue&type=template&id=4d778d88&ts=true"
import script from "./CommonModal.vue?vue&type=script&lang=ts"
export * from "./CommonModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__